import React, { useState, useEffect, useCallback } from "react";
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from "react-icons/bs";
import "./gallery.css";

const Carousel = ({ images }) => {
    const [slide, setSlide] = useState(0);

    const nextSlide = useCallback(() => {
        setSlide((prevSlide) =>
            prevSlide === images.length - 1 ? 0 : prevSlide + 1
        );
    }, [images]);

    const prevSlide = useCallback(() => {
        setSlide((prevSlide) =>
            prevSlide === 0 ? images.length - 1 : prevSlide - 1
        );
    }, [images]);

    const goToSlide = useCallback((index) => {
        setSlide(index);
    }, []);

    const autoSlideInterval = 3000;
    useEffect(() => {
        const intervalId = setInterval(() => {
            nextSlide();
        }, autoSlideInterval);

        return () => clearInterval(intervalId);
    }, [nextSlide, autoSlideInterval]);


    return (
        <div className="contai">
            <h1 className="head">Gallery</h1>
            <div className="carousel">
                <BsArrowLeftCircleFill
                    onClick={prevSlide}
                    className="arrow arrow-left"
                />
                {images.map((item, idx) => (
                    <img
                        src={item.src}
                        alt={item.alt}
                        key={idx}
                        className={slide === idx ? "slide" : "slide slide-hidden"}
                    />
                ))}
                <BsArrowRightCircleFill
                    onClick={nextSlide}
                    className="arrow arrow-right"
                />
                <span className="indicators">
                    {images.map((_, idx) => (
                        <button
                            key={idx}
                            className={
                                slide === idx
                                    ? "indicator"
                                    : "indicator indicator-inactive"
                            }
                            onClick={() => goToSlide(idx)}
                        ></button>
                    ))}
                </span>
            </div>
        </div>
    );
};

export default Carousel;
